import React from "react";
import DashboardPageTab from "../Tabs/DashboardPage";

const DashboardPage = (props) => {
	return <DashboardPageTab {...props} />;
};

export default DashboardPage;
